export default {
  "content": "<mask id=\"a\" style=\"mask-type:luminance\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"16\" height=\"19\"><path d=\"M16 0H0v19h16V0z\" fill=\"#fff\"/></mask><g mask=\"url(#a)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.078 5.49A.46.46 0 002 5.747v8.113a2.287 2.287 0 001.1 1.927l4.727 3.1a.327.327 0 00.346 0l4.727-3.1A2.286 2.286 0 0014 13.86V5.747a.46.46 0 00-.287-.427l-5.54-2.247a.447.447 0 00-.346 0L2.287 5.32a.46.46 0 00-.209.17zm8.825 3.97l-3.01 4.516a.751.751 0 01-.55.338h-.075a.753.753 0 01-.534-.218L5.23 12.591a.756.756 0 111.069-1.068l.85.857 2.506-3.762a.752.752 0 011.249.828v.015z\" fill=\"#C9CBD4\"/></g>",
  "attrs": {
    "width": "16",
    "height": "19",
    "viewBox": "0 0 16 19",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};